import axios from "axios";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { base_url } from "../../../Helpers/request"
import { metaDetails } from "../../../Reducer/metaReducer";
import ReactPixel from 'react-facebook-pixel';

export default function GotoTop() {

  const dispatch = useDispatch()

  const routePath = useLocation();


  const onTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }


//   const GoogleAnalytics = () => {
//     const script = document.createElement('script');
//     script.src = "https://www.googletagmanager.com/gtag/js?id=UA-G-8Z0PMKX58F";
//     script.async = true;
//     document.body.appendChild(script);
//     window.dataLayer = window.dataLayer || [];
//     function gtag() { window.dataLayer.push(arguments); }
//     gtag('js', new Date());
//     gtag('config', 'G-8Z0PMKX58F', { page_path: window.location.pathname });
// }



const LuckyOrange = () => {
  window.__lo_site_id = 113323;
  const wa = document.createElement('script');
  wa.type = 'text/javascript';
  wa.async = true;
  wa.src = 'https://d10lpsik1i8c69.cloudfront.net/w.js';
  var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(wa, s);
}

  useEffect(() => {
    //  Lucky Orange code
    LuckyOrange()
    //  End Lucky Orange code
    ReactPixel.init('779019602552749');
    ReactPixel.pageView();
    //  Google tag (gtag.js)
    onTop();
    // GoogleAnalytics()
    // End Google tag (gtag.js) 

    // meta tag api
    const pathname = window.location.pathname.slice(-1) == "/" ? window.location.pathname.slice(1,-1) : window.location.pathname.slice(1);
    axios.get(`${base_url}/common/metatag?url=${pathname}`).then(res => {
      if (res.data.status == 1) {
        dispatch(metaDetails(res.data.data))
      } else {
        dispatch(metaDetails(""))
      }
    }).catch(error => console.log(error))
  }, [routePath]);

  return null;

}